"use client";

export default function CryptoHint({ priceUSDNum }) {
  const fmtUSD = (n) =>
    Number.isFinite(n)
      ? new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: "USD",
        }).format(n)
      : null;

  return (
    <div className="mt-2 rounded-lg border border-border bg-background/30 px-3 py-2">
      <p className="text-xs font-medium text-textPrimary">
        Also payable with USDC on Base and Fogo
      </p>
      <p className="text-xs text-textPrimary">
        Product value: {fmtUSD(priceUSDNum)}
      </p>
      <p className="text-[11px] text-textPrimary">
        Final payable USDC amount and fees appear after selecting a payment method.
      </p>
    </div>
  );
}